// extracted by mini-css-extract-plugin
export default {"side-container":"index-module__side-container--CQuzc","sticky-wrapper":"index-module__sticky-wrapper--gJcei","side-container--infos":"index-module__side-container--infos--ICiLY"};